import {QuizSessionFeedback} from '@cp/model';
import {useCallback} from 'react';
import updateQuizSessionFeedbackDoc from '../../api/quizSession/updateQuizSessionFeedbackDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useUpdateQuizSessionFeedback() {
  const updateFn = useCallback(async (sessionId: string, feedback: QuizSessionFeedback) => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    return updateQuizSessionFeedbackDoc(uid, sessionId, feedback);
  }, []);

  const {fn, loading, error} = useFunctionWrap(updateFn);

  return {
    updateQuizSessionFeedback: fn,
    loading,
    error,
  };
}
